import React, { useState, useEffect } from "react";
import { useIdleTimer } from 'react-idle-timer';
import {
    Divider, Dialog, Grid, DialogActions, DialogContent, DialogTitle, Typography
} from "@material-ui/core";
import { Button } from "@packages/ui";


const timeout = 90000
// const promptBeforeIdle = 10000
const promptTimeout = 30000

const IdleTimerContainer = () => {
    const [state, setState] = useState('Active')
    const [remaining, setRemaining] = useState(timeout)
    const [open, setOpen] = useState(false)

    const baseUrl = window.location.origin;


    const onIdle = () => {
        setState('Idle')
        setOpen(false)

        location = `${baseUrl}/generic-checkin/login`
    }

    const onActive = () => {
        setState('Active')
        setOpen(false)
    }

    const onPrompt = () => {
        setState('Prompted')
        setOpen(true)
    }

    const { getRemainingTime, activate } = useIdleTimer({
        onIdle,
        onActive,
        onPrompt,
        promptTimeout,
        timeout,
        throttle: 500
    })

    useEffect(() => {
        const interval = setInterval(() => {
            setRemaining(Math.ceil(getRemainingTime() / 1000))
        }, 500)

        return () => {
            clearInterval(interval)
        }
    })

    const handleStillHere = () => {
        activate()
    }

    return (
        <Dialog open={open} maxWidth={"xs"} fullWidth={true} >
            <DialogTitle >
                <Typography variant="h1">Idle Alert</Typography>
            </DialogTitle>
            <DialogContent dividers variant="h1">
                <Typography variant="h3">You&apos;re inactive for 1 minute!</Typography>
                <Typography variant="h3">Logging out in {remaining} seconds.</Typography>
                <Typography variant="h3">You can select action below.</Typography>
            </DialogContent>
            <DialogActions >
                <Divider />
                <Grid spacing={1} style={{ marginTop: "2rem", marginBottom: "1rem" }} container direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={6} justifyContent="center">
                        <Button style={{ marginLeft: "10%" }} color="primary" size="small" variant="contained" onClick={handleStillHere}>
                            I&apos;m still here
              </Button>
                    </Grid>
                    <Grid item xs={6} justifyContent="end">
                        <Button style={{ marginLeft: "25%" }} color="primary" size="small" variant="contained" onClick={onIdle}>
                            Log Me Out
              </Button>
                    </Grid>

                </Grid>
            </DialogActions>
        </Dialog>
    );
}

export default IdleTimerContainer;
